import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'actions',
  imports: [],
  templateUrl: './actions.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './actions.component.scss',
})
export class ActionsComponent {}
